import React from 'react';

const ServiceControl = ({ isActive }) => {
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 16C16.6569 16 18 14.6569 18 13C18 11.3431 16.6569 10 15 10C13.3431 10 12 11.3431 12 13C12 14.6569 13.3431 16 15 16Z'
        stroke={isActive ? '#ffffffa3' : '#525876'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13 15.5V20L15 18.5L17 20V15.5'
        stroke={isActive ? '#ffffffa3' : '#525876'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 17H5C4.46957 17 3.96086 16.7893 3.58579 16.4142C3.21071 16.0391 3 15.5304 3 15V5C3 3.9 3.9 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15C20.9996 15.3507 20.9071 15.6952 20.7315 15.9988C20.556 16.3025 20.3037 16.5546 20 16.73'
        stroke={isActive ? '#ffffffa3' : '#525876'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6 7H18'
        stroke={isActive ? '#ffffffa3' : '#525876'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6 10H9'
        stroke={isActive ? '#ffffffa3' : '#525876'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6 13H8'
        stroke={isActive ? '#ffffffa3' : '#525876'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ServiceControl;
